import { Grid, GridSize, InputLabel, Select, SelectChangeEvent } from '@mui/material';
import { MenuItemStyled, StyledFormControl } from './DateRange.styles';

interface DateRangeProps {
  title: string;
  value: string;
  items: string[] | null;
  onChange: (event: SelectChangeEvent<string>) => void;
  cellSize?: GridSize;
}

export const DateRange = ({ title, items, value, onChange, cellSize = 6 }: DateRangeProps) => {
  return (
    <Grid item xs={12} sm={cellSize}>
      <StyledFormControl fullWidth>
        <InputLabel>{title}</InputLabel>
        <Select label={title} value={value} onChange={onChange}>
          {items?.map((value) => (
            <MenuItemStyled key={value} value={value}>
              {value}
            </MenuItemStyled>
          ))}
        </Select>
      </StyledFormControl>
    </Grid>
  );
};
